import React, {useState,useContext} from "react";
import {useTranslate} from 'react-polyglot';
import { DialogActions, DialogButton } from '@rmwc/dialog';
import ShowLoadingContext from '../../context/ShowLoadingContext';
import "./editAR.scss"
import AlertDialog from '../general/AlertDialog';
import Appcontext from '../app/AppContext';
import ExperienceService from "../../services/Experience";
import ActionButtons from "../actionsDialog/ActionButtons";
export default function ChangeToAd(props) {
    const context = useContext(Appcontext);
    const t = useTranslate();
    const { setShowLoading } = useContext(ShowLoadingContext)
    const [open, setOpen] = useState({
        title: '',
        subtitle: '',
        isOpen: false
    })
    const handleAccept = async() => {
        setShowLoading(true)
        await ExperienceService.ExperienceAd(props.data.experienceType,props.data.experienceId,!props.data.isAd, props.data.publicAlias);
        setShowLoading(false)
        context.page.refetch()
    }
    return (
        <>
            <AlertDialog
                title={open.title}
                bodyMessage={open.subtitle}
                setOpen={setOpen}
                open={open.isOpen}
                buttonMessage='OK'
            />
            <ActionButtons
                cancelText={t('actions.cancel')}
                acceptText={t('actions.accept')}
                onClickAccept={handleAccept}
            ></ActionButtons>
        </>
    )
}